import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IRegieBaremes } from "../../interface/regie";

export const getRegieBaremes = async (
  token: string,
  setBaremes: (baremes: IRegieBaremes) => void,
  dispatch: Function,
  setError: Function
) => {
  try {
    const response = await axios.get(`${urlAPI}/regie/baremes`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setBaremes(response.data.message);
  } catch (error: any) {
    console.error(error);
    setError("Impossible de récupérer les barèmes régie.");
    dispatch(showSnackbar("Erreur lors du chargement des barèmes régie.", "error"));
  }
};
